import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Chevron } from '@bibliocommons/deprecated-base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { StickyToggleButton } from '@bibliocommons/base-drawer';

import './BorrowingSidebarToggleButton.scss';

const BorrowingSidebarToggleButton = ({ drawerActions }) => (
  <StickyToggleButton
    className="cp-borrowing-sidebar-toggle-button"
    drawerActions={drawerActions}
    renderCompact={() => (
      <span>
        <Chevron.DoubleRight />
        <ScreenReaderMessage>
          <FormattedMessage id="section_title_my_borrowing" />
        </ScreenReaderMessage>
      </span>
    )}
    renderFull={() => (
      <span className="full-content">
        <Chevron.DoubleRight />
        <FormattedMessage id="section_title_my_borrowing" />
      </span>
    )}
  />
);

export default BorrowingSidebarToggleButton;

BorrowingSidebarToggleButton.propTypes = {
  drawerActions: PropTypes.objectOf(PropTypes.func)
};
